export const MODULE_NAME = "lcm";
